import type { PeptideGoal } from "@/config/peptide-stacks";

type QuizGoal = "recovery" | "anti-aging" | "performance" | "weight" | "skin" | "cognitive";

const QUIZ_GOAL_TO_STACK_GOAL: Readonly<Record<QuizGoal, PeptideGoal>> = {
	recovery: "recovery",
	"anti-aging": "anti-aging",
	performance: "recovery",
	weight: "weight-management",
	skin: "skin",
	cognitive: "cognitive",
};

export function mapQuizGoalToStackGoal(goal: string | null | undefined): PeptideGoal | null {
	if (!goal || !(goal in QUIZ_GOAL_TO_STACK_GOAL)) return null;
	return QUIZ_GOAL_TO_STACK_GOAL[goal as QuizGoal];
}

export function buildQuizStackBuilderHref({
	locale,
	channel,
	rawGoal,
	topProfileSlug,
}: {
	locale: string;
	channel: string;
	rawGoal: string | null | undefined;
	topProfileSlug: string | null;
}): string {
	const params = new URLSearchParams({ mode: "guided", src: "quiz" });
	const mappedGoal = mapQuizGoalToStackGoal(rawGoal);
	if (mappedGoal) params.set("goal", mappedGoal);
	if (topProfileSlug) params.set("s", topProfileSlug);
	if (rawGoal) params.set("src_slug", rawGoal);
	return `/${locale}/${channel}/stack-builder?${params.toString()}`;
}
